export function replaceSpacesWithUnderscores(text: string) {
    return text.replace(/ /g, '_')
}
